import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Header from './ComponentFragments/Header';
import Stepper from 'react-stepper-horizontal';

class DemonstratorThreeStep extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initData: [],
            threeStepData: [],
            currentStep: 1,
            step1Color: "#1eb5da",
            step2Color: "#808080",
            step3Color: "#808080",
            startEndSeg: ""
        };
        this.formatter = new Formatter();
        this.changeStep = this.changeStep.bind(this);
    }

    changeStep = (step) => {
        let displayData = [];
        switch (step) {
            case 1:
                displayData = [];
                this.state.initData.forEach(man => {
                    displayData.push(man);
                });
                displayData = _.remove(displayData, function(n) {
                    return n.step == 0;
                });
                this.setState({
                    threeStepData: displayData,
                    step1Color: "#1eb5da",
                    step2Color: "#808080",
                    step3Color: "#808080",
                    currentStep: 1
                });
                break;
            case 2:
                displayData = [];
                this.state.initData.forEach(man => {
                    displayData.push(man);
                });
                displayData = _.remove(displayData, function(n) {
                    return n.step == 1;
                });
                this.setState({
                    threeStepData: displayData,
                    step1Color: "#808080",
                    step2Color: "#1eb5da",
                    step3Color: "#808080",
                    currentStep: 2
                });
                break;
            case 3:
                displayData = [];
                this.state.initData.forEach(man => {
                    displayData.push(man);
                });
                displayData = _.remove(displayData, function(n) {
                    return n.step == 2;
                });
                this.setState({
                    threeStepData: displayData,
                    step1Color: "#808080",
                    step2Color: "#808080",
                    step3Color: "#1eb5da",
                    currentStep: 3
                });
                break;

        }
    }

    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let displayData = [];
        await dl.Get('/common/GetThreeStepDems', 200).then((response) => {
            this.setState({
                initData: response.data.demList,
                startEndSeg: "Demonstrator Three Step: " + response.data.startEndSeg
            });
            this.state.initData.forEach(man => {
                displayData.push(man);
            });
            displayData = _.remove(displayData, function(n) {
                return n.step == 0;
            });
            this.setState({
                threeStepData: displayData,
                currentStep: 1
            });
            this.props.loaderOff();
        })
    }

    render() {
        var circleStyle = {
            padding: 10,
            margin: 20,
            display: "inline-block",
            borderRadius: "50%",
            width: 80,
            height: 80,
            textAlign: "center",
            cursor: "pointer"
        };
        return (
            <div>
                <Header headerText={this.state.startEndSeg} hideSearch={true} />
                {/*<Stepper style={{paddingBottom:"100px"}} steps={this.state.steps} activeStep={this.state.currentStep} disabledSteps={[2]} size={100} circleFontSize={60}/>*/}
                <MDBRow>
                    <div style={{
                        padding: 10,
                        margin: 5,
                        display: "inline-block",
                        backgroundColor: this.state.step1Color,
                        borderRadius: "50%",
                        width: 80,
                        height: 80,
                        textAlign: "center",
                        cursor: "pointer"
                    }} onClick={() => this.changeStep(1)}>
                        <p style={{ paddingTop: "12px", fontSize: "20px" }}>Step 1</p>
                    </div>
                    <div style={{
                        padding: 10,
                        margin: 5,
                        display: "inline-block",
                        backgroundColor: this.state.step2Color,
                        borderRadius: "50%",
                        width: 80,
                        height: 80,
                        textAlign: "center",
                        cursor: "pointer"
                    }} onClick={() => this.changeStep(2)}>
                        <p style={{ paddingTop: "12px", fontSize: "20px" }}>Step 2</p>
                    </div>
                    <div style={{
                        padding: 10,
                        margin: 5,
                        display: "inline-block",
                        backgroundColor: this.state.step3Color,
                        borderRadius: "50%",
                        width: 80,
                        height: 80,
                        textAlign: "center",
                        cursor: "pointer"
                    }} onClick={() => this.changeStep(3)}>
                        <p style={{ paddingTop: "12px", fontSize: "20px" }}>Step 3</p>
                    </div>
                </MDBRow>
                <MDBRow>
                    {
                        this.state.threeStepData.map((dem) => {
                            return (
                                <MDBCol xl="3" lg="3" md="4" sm="12" className="mb-r" >
                                <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                    {/*<MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="users" />&nbsp;{dem.unitName.toUpperCase()}</MDBCardTitle>*/}
                                    <MDBCardTitle style={{ fontSize: "16px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{dem.demName}</MDBCardTitle>
                                    <hr />
                                    <MDBCardText>
                                        <MDBIcon far icon="id-card" />&nbsp;{dem.demCode}<br />
                                        <MDBIcon far icon="play-circle" />&nbsp;{dem.startSegment}<br />
                                            <MDBIcon icon="coins" />&nbsp;{this.formatter.formatCurrency(dem.sales)}
                                    </MDBCardText>
                                    <hr />
                                        {this.state.currentStep == 1 ? (
                                            <div className="flex-row text-center" >
                                                {dem.achieved ? (
                                                    <span style={{ fontSize: "14px" }}>Achieved Step 1:&nbsp;<MDBIcon icon="check" /></span>
                                                ) : (
                                                        <span style={{ fontSize: "14px" }}>Achieved Step 1:&nbsp;<MDBIcon icon="times" /></span>
                                                    )}

                                            </div>
                                        ) : (
                                                this.state.currentStep == 2 ? (
                                                    <div className="flex-row text-center" >
                                                        {dem.achieved ? (
                                                            <span style={{ fontSize: "14px" }}>Achieved Step 2:&nbsp;<MDBIcon icon="check" /></span>
                                                        ) : (
                                                                <span style={{ fontSize: "14px" }}>Achieved Step 2:&nbsp;<MDBIcon icon="times" /></span>
                                                            )}

                                                    </div>
                                                ): (
                                                        <div className="flex-row text-center" >
                                                            {dem.achieved ? (
                                                                <span style={{ fontSize: "14px" }}>Achieved Step 3:&nbsp;<MDBIcon icon="check" /></span>
                                                            ) : (
                                                                    <span style={{ fontSize: "14px" }}>Achieved Step 3:&nbsp;<MDBIcon icon="times" /></span>
                                                                )}

                                                        </div>
                                                    ) 
                                        )}
                                    </MDBCard>
                                    </MDBCol>
                            );
                        })
                    }
                </MDBRow>
            </div>

        )
    }
}

export default DemonstratorThreeStep;


